// import 'babel-polyfill';
import Vue from "vue";
import mxNative from "@midea/mx-native";
// import mxMonitor from "@midea/mx-monitor";
import mxNativeConfig from "../mx-configs/mx.native.config";
// import mxMonitorConfig from "../mx-configs/mx.monitor.config";
import fastclick from "./libs/fastclick";
new mxNative(mxNativeConfig);
// new mxMonitor(mxMonitorConfig);

let mxService = {};
["http", "locale", "owner", "router", "store", "token"].forEach((item) => {
  const module = require(`./libs/${item}/index.js`);
  Object.keys(module).forEach((key) => {
    console.log('key', key)
    if (key === "default") {
      if (module[key].install) {
        Vue.use(module[key]);
      }
      Object.keys(module[key]).forEach((k) => {
        if (k !== "install") {
          mxService[k] = module[key][k];
        }
      });
    } else {
      window.mx[key]
        ? console.error(`mx-serivce error: 已存在 ${key} 方法`)
        : (window.mx[key] = module[key]);
    }
  });
});

[
  "base64",
  "dateFormat",
  "debounce",
  "device",
  "querystring",
  "throttle",
].forEach((item) => {
  const module = require(`./libs/utils/${item}/index.js`);
  Object.keys(module.default).forEach((key) => {
    window.mx[key]
      ? console.error(`mx-serivce error: 已存在 ${key} 方法`)
      : (window.mx[key] = module.default[key]);
  });
});

if (process.env.MX_ENV !== "prod") {
  console.log("window mx apis: ", window.mx);
}

// 在全局上下文(global context)执行一次 fastclick 脚本
fastclick.attach(document.body);

// 改变状态栏背景色
// window.mx.statusBarColor(255, 255, 255, 1);
// 取消橡皮筋效果
// window.mx.setBounces(false);
// // 隐藏原生导航栏
// window.mx.hideNav();
// // 隐藏悬浮按钮
// window.mx.hideFloat();
// // 设置标准化导航
// window.mx.navigationRightButtons([1]);

export default mxService;
